// "1 area", "2 areas". Pure: no React, router or Firebase imports.

/** `count` with its noun: pluralize(1, 'area') is "1 area", pluralize(2, 'area') is "2 areas". */
export function pluralize(count: number, singular: string, plural: string = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

/** "A", "A and B" or "A, B and C". An empty list gives "". */
export function joinNames(names: readonly string[]): string {
  if (names.length <= 1) return names.join('');
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
